<router-outlet></router-outlet>
<footer>
    <div class="row w-100">
    <div class="col text-center">
      Dr. Blumer & Partner Asset Management AG,<br>
      Landstrasse 8, 9496 Balzers, Liechtenstein,<br>
      E-Mail: info[at]dr-blumer.li
    </div>
  </div>
</footer>

